import { ExchangeRateCalculator, ExchangeRateList } from "@/modules/exchangeRate/components";
import { Heading } from "@ab.uitools/ui-library/components/Heading";
import { useTranslation } from "react-i18next";

export const ExchangeRate = () => {
  const { t } = useTranslation();

  return (
    <div className="full-width main-grid-wrapper page-body h-fit-content">
      <div className="full-width flexbox justify-content--center">
        <div className="main-grid mb-32">
          <div className="main-grid--left-widgets">
            <div className="full-width mb-20 content-title-wrapper">
              <Heading className="content-title" size="xsmall" weight="bolder">
                {t("exchangeRate.title")}
              </Heading>
            </div>
            <ExchangeRateList isInWidget/>
          </div>
          <div className="main-grid--right-widgets">
            <div className="full-width mb-20 content-title-wrapper">
              <Heading className="content-title" size="xsmall" weight="bolder">
                {t("exchangeRate.title")}
              </Heading>
            </div>
            <ExchangeRateCalculator/>
          </div>
        </div>
      </div>
    </div>
  );
};
